import { render, staticRenderFns } from "./modalJustificacion.vue?vue&type=template&id=84d82f74&"
import script from "./modalJustificacion.vue?vue&type=script&lang=js&"
export * from "./modalJustificacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports